export interface CommandsResponse {
  comando: string;
  comandoTipoId: number;
  dataEnvio: string;
  dataRequisicao: string;
  dataResposta: string;
  id: number;
  resposta: string;
  serial: string;
  sistema: string;
  statusId: number;
  timeout: number;
  parametros?: string;
  idDb: number;
}

export class CommandinfoType {
  id: number;
  comandoId: number;
  nome: string;
  dispositivoModeloId?: number;
  dispositivoModelo?: string;
  valor?: boolean;
  quantidadeValor: number;
  observacaoHTML: string;
  observacao: string;
  sistemaNome: string;
  sistemaAux?: string[];
  exemplo: string;
  canalEnvioId: number;
  create_user?: number;
  update_user?: number;
  create_time?: number;
  update_time?: number;
  isAccessory: boolean

  constructor(item: CommandinfoType) {
    this.id = item.id;
    this.nome = item.nome;
    this.canalEnvioId = item.canalEnvioId;
    this.comandoId = item.comandoId;
    this.valor = false;
    this.dispositivoModelo = '';
    this.dispositivoModeloId = 0;
    this.observacaoHTML = '';
    this.observacao = '';
    this.sistemaNome = '';
    this.exemplo = '';
    this.quantidadeValor = 0;
    this.isAccessory = item.isAccessory;
  }
  clone(other: CommandinfoType): void {
    let k: keyof CommandinfoType;
    for (k in other) {
      const v = other[k];
      (this[k] as typeof v) = v;
    }
  }
}
export interface DeviceModels {
  dispositivoModeloId: number;
  dispositivoModelo: string;
}

export interface AccessoryModels {
  acessorioModeloId: number;
  acessorioModelo: string;
}

export interface CommandSelect {
  id: number;
  nome: string;
  dispositivoModeloId: number;
  dispositivoModelo: string;
  comandoId: number;
  valor: boolean;
  observacaoHTML: string;
  canalEnvio: string;
  exemplo: string;
  param: string;
  paramAux: string;
  timeout: any;
  seriais: string;
  ambiente: string;
  idAccessory ?: number;
}

export class SelectAccessory {
  tipo: number;
  accessoryModeloId: number;
  accessoryModel: number;
  nome: string;

  constructor(item : any) {
    this.tipo = item.comandoId;
    this.accessoryModeloId = item.dispositivoModeloId;
    this.accessoryModel = item.dispositivoModelo;
    this.nome = item.nome;
  }
}

export class CommandToSend {
  serial: string;
  tipo: number;
  sistema: string;
  param?: string;
  timeout?: number;
  idAccessory?: number;

  constructor() {
    (this.serial = ''), (this.tipo = -1), (this.sistema = 'logan');
  }
}

export interface ComboResp {
  id: number;
  nome: string;
}

export type BatchCommandTargetType = 'SERIAL' | 'EQUIPAMENTO';

export type BatchCommandScheduleDay =
  | 'SEGUNDA'
  | 'TERCA'
  | 'QUARTA'
  | 'QUINTA'
  | 'SEXTA'
  | 'SABADO'
  | 'DOMINGO';

export interface BatchCommandSchedule {
  diaSemana: BatchCommandScheduleDay;
  horaInicio: string; // formato "HH:mm"
  horaFim: string; // formato "HH:mm"
}

export interface BatchCommandRequest {
  nome: string;
  tipoEnvio: BatchCommandTargetType;
  seriais?: string[];
  equipamento?: string;
  firmware?: string;
  comando?: CommandToSend;
  agendamentos?: BatchCommandSchedule[];
  userId?: number;
}

export interface BatchCommandInfo {
  serial: string | null;
  tipo: number | null;
  sistema: string | null;
  param: string | null;
  nome: string;
  timeout: number | null;
  idAccessory: number | null;
}

export interface BatchCommandListItem {
  id: number;
  nome: string;
  quantidade: number;
  percentualEnviado: number;
  comando: BatchCommandInfo;
  status: string;
  createTime: number;
  updateTime?: number;
  tipoEnvio?: BatchCommandTargetType;
  equipamento?: string;
  firmware?: string;
  userId?: number;
  userName?: string;
}

export interface BatchCommandFilter {
  nome?: string;
  dataInicial?: number;
  dataFinal?: number;
  idComando?: number;
  status?: string;
  serial?: string;
}

export interface BatchCommandListResponse {
  total: number;
  size: number;
  hasNext: boolean;
  page: number;
  items: BatchCommandListItem[];
}

export interface BatchCommandSerialItem {
  id: number;
  serial: string;
  status: string;
  createTime: number;
  updateTime?: number;
}

export interface TotalizadorComandos {
  pendente: number;
  enviando: number;
  executado: number;
  cancelado: number;
  timeout: number;
  erroExecucao: number;
  naoEncontrado: number;
}

export interface BatchCommandDetailResponse {
  id: number;
  nome: string;
  tipoEnvio: string;
  equipamento?: string;
  firmware?: string;
  agendamento?: BatchCommandSchedule[];
  nomeComando?: string;
  parametroComando?: string;
  timeout?: string;
  status: string;
  quantidade: number;
  createTime: number;
  updateTime?: number;
  page: number;
  size: number;
  total: number;
  seriais: BatchCommandSerialItem[];
  totalizadorComandos: TotalizadorComandos;
}

export enum Systems {
  'geo' = 1,
  'geoFrotas',
}

export enum Timeout {
  'Padrão (7 minutos)' = 420,
  '10 minutos' = 600,
  '30 minutos' = 1800,
  '1 hora' = 3600,
  '6 horas' = 21600,
  '12 horas' = 43200,
  '1 dia' = 86400,
  '3 dias' = 259200,
  '7 dias' = 604800,
}

export enum CanalEnvio {
  GPRS = 1,
  LORAWAN,
  SMS,
  SATELITAL,
}
export enum CommandStatusEnum {
  PENDENTE = 1,
  ENVIANDO = 2,
  EXECUTADO = 3,
  CANCELADO = 4,
  TIMEOUT = 5,
  ERRO_EXECUCAO = 6,
  NAO_ENCONTRADO = 7,
  ENVIADO_DENOX = 8,
}

const commandStatus: Array<string> = Object.keys(CommandStatusEnum).filter(
  (key) => isNaN(+key)
);

export const CommandStatus = {
  commandStatusColor(status: any) {
    switch (status) {
      case CommandStatusEnum.PENDENTE:
      case CommandStatusEnum.ENVIANDO:
      case CommandStatusEnum.ENVIADO_DENOX:
        return 'table-info';
      //   return '#CFF1EF';
      case CommandStatusEnum.EXECUTADO:
        //      return '#C3E5AE';
        return 'table-success';

      case CommandStatusEnum.CANCELADO:
        //    return '#FFEFA1';
        return 'table-warning';

      case CommandStatusEnum.TIMEOUT:
      case CommandStatusEnum.ERRO_EXECUCAO:
      case CommandStatusEnum.NAO_ENCONTRADO:
        return 'table-danger';

      //    return '#FFA8A8';
      default:
        return 'table-info';

      //    return '#CFF1EF';
    }
  },
};
